<template>
  <div>
    <h1>Message 消息提示</h1>
    <p class="page-desc">全局展示操作反馈信息。</p>

    <k-row gutter="16">
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer
          title="普通提示"
          :code="PTTS"
          desc="信息提醒反馈，默认在1.5秒后消失。"
        >
          <k-button @click="info">打开消息提示</k-button>
        </demo-viewer>

        <demo-viewer title="修改延时" :code="XGYS" desc="自定义时长。">
          <k-button @click="time" :disabled="duration != 10"
            >{{ this.duration }}秒后自动消失</k-button
          >
        </demo-viewer>
      </k-col>
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer
          title="其他提示类型"
          :code="QTTSLX"
          desc="包括成功、失败、警告。"
        >
          <k-button @click="success">成功</k-button>
          <k-divider type="vertical" />
          <k-button @click="warning">警告</k-button>
          <k-divider type="vertical" />
          <k-button @click="error">错误</k-button>
        </demo-viewer>

        <demo-viewer title="可关闭" :code="KGB" desc="可以添加关闭按钮。">
          <k-button @click="closable">显示一个可以手动关闭的提示</k-button>
        </demo-viewer>
      </k-col>
    </k-row>

    <table class="doc-table">
      <caption>
        <h3>属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>content</td>
          <td>提示内容</td>
          <td>String</td>
          <td>-</td>
        </tr>
        <tr>
          <td>type</td>
          <td>主题，可选值为success、warning、info、error</td>
          <td>String</td>
          <td>info</td>
        </tr>
        <tr>
          <td>duration</td>
          <td>自动关闭的延时，单位秒，不关闭可以写 0</td>
          <td>Number</td>
          <td>1.5</td>
        </tr>
        <tr>
          <td>closable</td>
          <td>是否显示关闭按钮</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>onClose</td>
          <td>关闭时的回调</td>
          <td>Function</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      duration: 10,
      PTTS:
        `
  <template>
    <k-button @click="info">打开消息提示</k-button>
  </template>
  <script>
    export default {
      methods: {
        info () {
            this.$Message("这是一条消息提示");
        }
      }
    }
  </` +
        `script>
      `,
      QTTSLX:
        `
  <template>
    <k-button @click="success">成功</k-button>
    <k-button @click="warning">警告</k-button>
    <k-button @click="error">错误</k-button>
  </template>
  <script>
    export default {
      methods: {
        success() {
          this.$Message({
            content: "恭喜你，这是一条成功消息",
            type: "success"
          });
        },
        warning() {
          this.$Message({
            content: "警告哦，这是一条警告消息",
            type: "warning"
          });
        },
        error() {
          this.$Message({
            content: "错了哦，这是一条错误消息",
            type: "error"
          });
        }
      }
    }
  </` +
        `script>
      `,
      XGYS:
        `
  <template>
    <k-button @click="time">10秒后自动消失</k-button>
  </template>
  <script>
    export default {
      methods: {
        time() {
          this.$Message({
            content: "我将在10秒后消失",
            duration: 10
          });
        }
      }
    }
  </` +
        `script>
      `,
      KGB:
        `
  <template>
    <k-button @click="closable">显示一个可以手动关闭的提示</k-button>
  </template>
  <script>
    export default {
      methods: {
        closable() {
          this.$Message({
            content: "我可以被手动关闭",
            duration: 0,
            closable: true,
            onClose: () => {
              this.$Message("这是关闭后的回调");
            }
          });
        }
      }
    }
  </` +
        `script>
      `
    };
  },
  methods: {
    info() {
      this.$Message("这是一条消息提示");
    },
    success() {
      this.$Message({
        content: "恭喜你，这是一条成功消息",
        type: "success"
      });
    },
    warning() {
      this.$Message({
        content: "警告哦，这是一条警告消息",
        type: "warning"
      });
    },
    error() {
      this.$Message({
        content: "错了哦，这是一条错误消息",
        type: "error"
      });
    },
    time() {
      this.$Message({
        content: "我将在10秒后消失",
        duration: 10
      });

      this.interval = setInterval(() => {
        if (this.duration > 0) {
          this.duration = this.duration - 1;
        } else {
          this.duration = 10;
          clearInterval(this.interval);
        }
      }, 1000);
    },
    closable() {
      this.$Message({
        content: "我可以被手动关闭",
        duration: 0,
        closable: true,
        onClose: () => {
          this.$Message("这是关闭后的回调");
        }
      });
    }
  }
};
</script>
